/* Shopify is the source of truth for catalog, search and cart. */
function safeStoreUrl(value) {
  try {
    const url = new URL(value, location.origin);
    return url.origin === location.origin && /^https?:$/.test(url.protocol) ? url.pathname + url.search + url.hash : null;
  } catch { return null; }
}
async function shopifyRequest(url, body) {
  const response = await fetch(url, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(body)});
  // A non-JSON error page (proxy/5xx) must still surface the friendly message, not a JSON parse error.
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.description || data.message || (document.documentElement.dataset.updateError || 'Unable to update your bag. Please try again.'));
  return data;
}
// Shopify Customer Privacy state -> banner step. An unanswered "preferences" value means the visitor has not
// chosen yet: show the banner, and keep optional processing off until they do.
function consentStep(current) {
  const answered = Boolean(current.preferences);
  return {show: !answered, restrict: !answered && !current.analytics};
}
document.addEventListener('DOMContentLoaded', () => {
  const backdrop = document.querySelector('.drawer-backdrop');
  const menuButton = document.querySelector('.menu-trigger');
  const menuHome = menuButton?.parentElement;
  const menuPanel = document.getElementById('menu-drawer');
  const menuSurface = menuPanel?.querySelector('.menu-surface');
  let menuAnimations = [], menuRevision = 0;
  function moveMenuControl(open) {
    if (!menuButton || !menuSurface) return;
    const revision = ++menuRevision;
    const icon = menuButton.querySelector('svg');
    const start = icon.getBoundingClientRect();
    const lines = Array.from(icon.children);
    const current = lines.map(line => ({transform:getComputedStyle(line).transform, opacity:getComputedStyle(line).opacity}));
    const color = getComputedStyle(menuButton).color;
    const home = menuHome.getBoundingClientRect();
    const destination = menuPanel.querySelector('.menu-close-destination').getBoundingClientRect();
    // Remove the surface's current slide offset to obtain its settled destination.
    const slide = new DOMMatrixReadOnly(getComputedStyle(menuSurface).transform).m41;
    const rtl = getComputedStyle(menuHome).direction === 'rtl';
    const endX = open ? destination.x - slide + destination.width / 2 : (rtl ? home.right - 10 : home.left + 10);
    const endY = open ? destination.y + destination.height / 2 : home.y + home.height / 2;
    menuAnimations.forEach(animation => animation.cancel());
    menuHome.style.width = home.width + 'px';
    menuHome.style.height = home.height + 'px';
    menuHome.classList.add('is-travelling');
    menuHome.classList.toggle('is-open', open);
    (open ? menuPanel : document.body).append(menuButton);
    menuButton.classList.add('is-travelling');
    menuButton.style.setProperty('--menu-control-color', open ? getComputedStyle(menuSurface).color : getComputedStyle(menuHome).color);
    menuButton.setAttribute('aria-label', open ? menuButton.dataset.closeLabel : menuButton.dataset.openLabel);
    const timing = {duration:750, easing:'cubic-bezier(.22,1,.36,1)', fill:'both'};
    const position = (x,y) => `translate3d(${x - 22}px,${y - 22}px,0)`;
    menuAnimations = [menuButton.animate([
      {transform:position(start.x + start.width/2,start.y + start.height/2),color},
      {transform:position(endX,endY),color:menuButton.style.getPropertyValue('--menu-control-color')}
    ],timing)];
    const transforms = open ? ['rotate(45deg) translateY(6px)','scaleX(0)','rotate(-45deg) translateY(-6px)'] : ['none','none','none'];
    lines.forEach((line,index) => menuAnimations.push(line.animate([current[index],{transform:transforms[index],opacity:open && index===1 ? 0 : 1}],timing)));
    menuAnimations[0].onfinish = () => {
      if (revision !== menuRevision || open) return;
      const focused = document.activeElement === menuButton;
      menuHome.prepend(menuButton);
      menuButton.classList.remove('is-travelling');
      menuHome.classList.remove('is-travelling');
      menuHome.style.removeProperty('width');
      menuHome.style.removeProperty('height');
      menuAnimations.forEach(animation => animation.cancel());
      menuAnimations = [];
      if (focused) menuButton.focus({preventScroll:true});
    };
  }
  window.addEventListener('resize', () => {
    if (menuButton?.classList.contains('is-travelling')) moveMenuControl(activePanel === menuPanel || searchOverMenu);
  });
  let activePanel, returnFocus, previousOverflow = '';
  const focusable = panel => Array.from(panel.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled),select,textarea,[tabindex="0"]')).filter(el => el.tabIndex !== -1 && el.getClientRects().length);

  // Search is one surface with two entry points. From the header it unfolds from the top edge. From the
  // menu, the field starts exactly over the menu's Search row (FLIP) and travels up, so the row becomes the field.
  const searchPanel = document.getElementById('search-drawer');
  const searchInput = document.getElementById('PredictiveSearchInput');
  const searchResults = document.getElementById('PredictiveSearchResults');
  const searchUI = searchPanel && {
    surface: searchPanel.querySelector('.search-surface'),
    field: searchPanel.querySelector('.search-field'),
    icon: searchPanel.querySelector('.search-field-icon svg'),
    hint: searchPanel.querySelector('.search-field-hint'),
    line: searchPanel.querySelector('.search-field-line'),
    close: searchPanel.querySelector('.search-field-close'),
    extras: searchPanel.querySelector('.search-extras')
  };
  const SEARCH_MS = 800, SEARCH_EASE = 'cubic-bezier(.22,1,.36,1)';
  let searchMotion = [], resultsMotion = [], searchRevision = 0, searchRow = null, searchOverMenu = false, menuReturnFocus;

  function rowTransform(row) {
    // Maps the resting field's icon onto the row's icon, scaled so the hint text matches the row label.
    const rowIcon = row.querySelector('svg').getBoundingClientRect();
    const scale = parseFloat(getComputedStyle(row.querySelector('span')).fontSize) / parseFloat(getComputedStyle(searchUI.hint).fontSize);
    const field = searchUI.field.getBoundingClientRect(), icon = searchUI.icon.getBoundingClientRect();
    const ox = getComputedStyle(searchUI.field).direction === 'rtl' ? field.right : field.left, oy = field.top + field.height / 2;
    const dx = rowIcon.left + rowIcon.width / 2 - ox - scale * (icon.left + icon.width / 2 - ox);
    const dy = rowIcon.top + rowIcon.height / 2 - oy - scale * (icon.top + icon.height / 2 - oy);
    return `translate(${dx}px,${dy}px) scale(${scale})`;
  }
  function animateSearch(open, row) {
    // Snapshot live values first so an interrupted open/close reverses from exactly where it is.
    const parts = Object.values(searchUI);
    const live = new Map(parts.map(el => { const style = getComputedStyle(el); return [el, {transform:style.transform, opacity:style.opacity}]; }));
    const resuming = searchMotion.some(animation => animation.playState === 'running');
    searchMotion.concat(resultsMotion).forEach(animation => animation.cancel());
    searchMotion = [];
    resultsMotion = [];
    const shared = row && rowTransform(row);
    const run = (el, from, to, timing) => searchMotion.push(el.animate([from && !resuming ? from : live.get(el), to], {duration:SEARCH_MS, easing:SEARCH_EASE, fill:'both', ...timing}));
    if (open) {
      run(searchUI.surface, {transform:'scaleY(0.001)', opacity:1}, {transform:'none', opacity:1});
      if (shared) {
        run(searchUI.field, {transform:shared, opacity:1}, {transform:'none', opacity:1});
        run(searchUI.hint, {transform:'none', opacity:1}, {transform:'none', opacity:.5}, {delay:460, duration:340});
        run(searchUI.line, {transform:'scaleX(0.001)', opacity:1}, {transform:'none', opacity:1}, {delay:380, duration:420});
      } else {
        run(searchUI.field, {transform:'translateY(-12px)', opacity:0}, {transform:'none', opacity:1}, {delay:90, duration:710});
        run(searchUI.line, {transform:'scaleX(0.001)', opacity:1}, {transform:'none', opacity:1}, {delay:200, duration:600});
      }
      run(searchUI.close, {transform:'translateX(-6px)', opacity:0}, {transform:'none', opacity:1}, {delay:420, duration:380});
      run(searchUI.extras, {transform:'translateY(-6px)', opacity:0}, {transform:'none', opacity:1}, {delay:340, duration:460});
    } else {
      run(searchUI.close, null, {transform:'translateX(-6px)', opacity:0}, {duration:220});
      run(searchUI.extras, null, {transform:'translateY(-6px)', opacity:0}, {duration:260});
      run(searchUI.line, null, {transform:'scaleX(0.001)', opacity:1}, {duration:340});
      if (shared) {
        run(searchUI.hint, null, {transform:'none', opacity:1}, {duration:300});
        run(searchUI.field, null, {transform:shared, opacity:1});
        run(searchUI.surface, null, {transform:'scaleY(0.001)', opacity:1}, {delay:60, duration:740});
      } else {
        run(searchUI.field, null, {transform:'translateY(-10px)', opacity:0}, {duration:380});
        run(searchUI.surface, null, {transform:'scaleY(0.001)', opacity:1}, {delay:100, duration:640});
      }
    }
    return Promise.all(searchMotion.map(animation => animation.finished));
  }
  function showSearch(row) {
    const revision = ++searchRevision;
    searchRow = row;
    if (row) row.style.opacity = '0';
    searchPanel.classList.add('active');
    searchPanel.focus({preventScroll:true});
    // Focus the field once it has settled so the caret never appears mid-flight.
    animateSearch(true, row).then(() => {
      if (revision === searchRevision && activePanel === searchPanel) searchInput?.focus({preventScroll:true});
    }, () => {});
  }
  function hideSearch() {
    const revision = ++searchRevision, row = searchRow;
    animateSearch(false, row).then(() => {
      if (revision !== searchRevision) return;
      searchPanel.classList.remove('active');
      row?.style.removeProperty('opacity');
      searchRow = null;
    }, () => {});
  }
  function showResults(update) {
    // Resize the surface from its previous height and ease the new results in, instead of popping.
    const before = searchUI.surface.getBoundingClientRect().height;
    update();
    if (activePanel !== searchPanel) return;
    const after = searchUI.surface.getBoundingClientRect().height;
    resultsMotion.forEach(animation => animation.cancel());
    resultsMotion = [searchResults.animate([{opacity:0, transform:'translateY(6px)'}, {opacity:1, transform:'none'}], {duration:220, easing:'ease-out'})];
    if (before && after && Math.abs(before - after) > 1) resultsMotion.push(searchUI.surface.animate([{transform:`scaleY(${before / after})`}, {transform:'none'}], {duration:260, easing:SEARCH_EASE}));
  }

  function closeDrawer(restore = true) {
    if (!activePanel) return;
    if (activePanel === menuPanel) {
      moveMenuControl(false);
      menuSurface.classList.remove('active');
    }
    if (activePanel === searchPanel) hideSearch();
    else activePanel.classList.remove('active');
    activePanel.inert = true;
    activePanel.setAttribute('aria-hidden','true');
    if (activePanel === searchPanel && searchOverMenu) {
      // Step back down into the menu instead of dismissing it; the field travels back into its row.
      searchOverMenu = false;
      document.querySelectorAll('[data-drawer-trigger="search-drawer"]').forEach(el => el.setAttribute('aria-expanded','false'));
      activePanel = menuPanel;
      menuPanel.inert = false;
      menuSurface.classList.remove('is-under-search');
      const row = returnFocus;
      returnFocus = menuReturnFocus;
      if (restore && row?.isConnected) row.focus({preventScroll:true});
      return;
    }
    document.querySelectorAll('[data-drawer-trigger]').forEach(el => el.setAttribute('aria-expanded','false'));
    document.querySelectorAll('[data-drawer-background]').forEach(el => { el.inert = false; });
    backdrop?.classList.remove('active');
    document.body.style.overflow = previousOverflow;
    activePanel = null;
    if (menuButton) menuButton.inert = false;
    if (restore && returnFocus?.isConnected) returnFocus.focus();
  }
  function openDrawer(id, trigger) {
    const panel = document.getElementById(id);
    if (!panel || !backdrop) return;
    if (panel === searchPanel && activePanel === menuPanel && menuPanel.contains(trigger)) {
      // Search rises above the menu; the menu stays open underneath (inert) and returns when Search closes.
      searchOverMenu = true;
      menuReturnFocus = returnFocus;
      returnFocus = trigger;
      menuPanel.inert = true;
      menuSurface.classList.add('is-under-search');
      activePanel = searchPanel;
      searchPanel.inert = false;
      searchPanel.setAttribute('aria-hidden','false');
      document.querySelectorAll('[data-drawer-trigger="search-drawer"]').forEach(el => el.setAttribute('aria-expanded','true'));
      showSearch(trigger);
      return;
    }
    const origin = activePanel?.contains(trigger) ? returnFocus : trigger || document.activeElement;
    closeDrawer(false);
    if (activePanel) closeDrawer(false);
    returnFocus = origin;
    previousOverflow = document.body.style.overflow;
    activePanel = panel;
    panel.inert = false;
    panel.setAttribute('aria-hidden','false');
    panel.classList.add('active');
    if (panel === menuPanel) {
      moveMenuControl(true);
      menuSurface.classList.add('active');
    }
    backdrop.dataset.drawer = id;
    backdrop.classList.add('active');
    document.body.style.overflow = 'hidden';
    document.querySelectorAll('[data-drawer-background]').forEach(el => { el.inert = true; });
    if (menuButton) menuButton.inert = panel !== menuPanel;
    document.querySelectorAll('[data-drawer-trigger]').forEach(el => el.setAttribute('aria-expanded',String(el.dataset.drawerTrigger === id)));
    if (panel === menuPanel) menuButton.focus();
    else if (panel === searchPanel) showSearch(null);
    else (focusable(panel)[0] || panel).focus();
  }
  document.querySelectorAll('[data-drawer-trigger]').forEach(el => {
    el.setAttribute('aria-controls',el.dataset.drawerTrigger);
    el.setAttribute('aria-expanded','false');
  });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-drawer-trigger]');
    if (trigger) {
      event.preventDefault();
      if (trigger === menuButton && activePanel === menuPanel) closeDrawer();
      else openDrawer(trigger.dataset.drawerTrigger,trigger);
    }
    if (event.target.closest('[data-drawer-close]') || event.target === backdrop) closeDrawer();
  });
  document.addEventListener('keydown', event => {
    if (!activePanel) return;
    // Typing while the search surface is still opening goes straight into the field instead of being lost.
    if (activePanel === searchPanel && document.activeElement === searchPanel && event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) searchInput?.focus({preventScroll:true});
    if (event.key === 'Escape') { event.preventDefault(); closeDrawer(); }
    if (event.key === 'Tab' && activePanel) {
      const items = focusable(activePanel), first = items[0], last = items[items.length-1];
      if (!first) { event.preventDefault(); activePanel.focus(); }
      else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  const cartUrl = document.documentElement.dataset.cartUrl;
  const status = document.getElementById('StoreStatus');
  let cartBusy = false;
  async function refreshCart() {
    const response = await fetch(cartUrl,{credentials:'same-origin'});
    if (!response.ok) throw new Error((document.documentElement.dataset.refreshError || 'Your bag was updated. Open the bag page to see it.'));
    const page = new DOMParser().parseFromString(await response.text(),'text/html');
    const replacement = page.querySelector('#CartDrawerContent');
    if (!replacement) throw new Error((document.documentElement.dataset.refreshError || 'Your bag was updated. Open the bag page to see it.'));
    document.getElementById('CartDrawerContent').replaceChildren(...replacement.childNodes);
    const count = page.getElementById('CartCount');
    if (count) document.getElementById('CartCount').textContent = count.textContent;
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count?.textContent || '0'; el.hidden = el.textContent === '0'; });
  }
  // Added from a page (not from inside the bag): the product photo lifts off as a small disc and arcs up into the bag
  // icon, the icon answers with a bump, then the bag opens and its contents settle in (revealBag).
  function flyToBag(form, button) {
    const bag = document.querySelector('.site-header [data-drawer-trigger="cart-drawer"]');
    if (!bag) return Promise.resolve();
    // Start from the photo actually on screen (the gallery may be on its second slide), else from the button.
    const visible = r => r.width && r.bottom > 0 && r.top < innerHeight && r.left > -2 && r.right < innerWidth + 2;
    const photos = [...(form.closest('[data-fly-scope]')?.querySelectorAll('[data-fly-image]') || []), ...(form.closest('.discovery-feature')?.querySelectorAll('img') || [])];
    const shown = photos.find(el => visible(el.getBoundingClientRect())), photo = shown?.matches('img') ? shown : shown?.querySelector('img');
    const origin = shown ? shown.getBoundingClientRect() : button?.getBoundingClientRect();
    if (!origin) return Promise.resolve();
    const to = bag.getBoundingClientRect(), size = 88;
    const x0 = origin.left + origin.width / 2 - size / 2, y0 = origin.top + origin.height / 2 - size / 2;
    const dx = to.left + to.width / 2 - size / 2 - x0, dy = to.top + to.height / 2 - size / 2 - y0;
    const disc = document.createElement('div');
    disc.className = 'bag-flyer';
    disc.setAttribute('aria-hidden', 'true');
    Object.assign(disc.style, {left:`${x0}px`, top:`${y0}px`, width:`${size}px`, height:`${size}px`});
    if (photo) disc.style.backgroundImage = `url("${photo.currentSrc || photo.src}")`;
    document.body.append(disc);
    const flight = disc.animate([
      {transform:'translate(0, 0) scale(.4)', opacity:0},
      {transform:'translate(0, -24px) scale(1)', opacity:1, offset:.18},
      {transform:`translate(${dx * .45}px, ${Math.min(dy, 0) * .45 - 90}px) scale(.8)`, opacity:1, offset:.55},
      {transform:`translate(${dx}px, ${dy}px) scale(.18)`, opacity:.85}
    ], {duration:820, easing:'cubic-bezier(.45,.05,.35,1)'});
    return flight.finished.then(() => {
      disc.remove();
      bag.animate([{transform:'scale(1)'}, {transform:'scale(1.32) rotate(-6deg)', offset:.4}, {transform:'scale(1)'}], {duration:520, easing:'cubic-bezier(.22,1,.36,1)'});
      document.getElementById('CartCount')?.animate([{transform:'scale(1)'}, {transform:'scale(1.6)', offset:.35}, {transform:'scale(1)'}], {duration:520, easing:'cubic-bezier(.22,1,.36,1)'});
    }, () => disc.remove());
  }
  function revealBag() {
    const drawer = document.getElementById('cart-drawer');
    drawer?.querySelectorAll('.cart-line, .drawer-body > :not(.cart-lines), .drawer-footer > *').forEach((el, i) => el.animate([{opacity:0, transform:'translateY(14px)'}, {opacity:1, transform:'none'}], {duration:560, delay:180 + i * 70, easing:'cubic-bezier(.22,1,.36,1)', fill:'backwards'}));
    drawer?.querySelector('.cart-line')?.animate([{backgroundColor:'rgba(121, 80, 79, .14)'}, {backgroundColor:'rgba(121, 80, 79, 0)'}], {duration:1600, delay:500, easing:'ease-out'});
  }
  // A card added from inside the open bag lifts, arcs down into the checkout button, and the button opens out from where it lands.
  // The copy leaves its section, so it keeps the section's look (the Discovery card's gold edge) inline.
  function copyCard(card) {
    const copy = card.cloneNode(true), look = getComputedStyle(card);
    Object.assign(copy.style, {background:look.background, borderColor:look.borderColor});
    return copy;
  }
  function flyToCheckout({rect, card, hadCheckout}) {
    const drawer = document.getElementById('cart-drawer'), checkout = drawer.querySelector('.cart-checkout');
    const body = drawer.querySelectorAll('.drawer-body > :not(.cart-lines), .cart-line');
    body.forEach((el, i) => el.animate([{opacity:0, transform:'translateY(-10px)'}, {opacity:1, transform:'none'}], {duration:520, delay:120 + i * 60, easing:'cubic-bezier(.22,1,.36,1)', fill:'backwards'}));
    if (!checkout) return;
    const box = drawer.getBoundingClientRect(), to = checkout.getBoundingClientRect(), FLY = 780, LAND = FLY - 60;
    const ghost = document.createElement('div');
    card.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
    ghost.className = 'cart-ghost';
    ghost.setAttribute('aria-hidden','true');
    ghost.inert = true;
    Object.assign(ghost.style, {left:`${rect.left - box.left}px`, top:`${rect.top - box.top}px`, width:`${rect.width}px`, height:`${rect.height}px`});
    ghost.append(card);
    drawer.append(ghost);
    // Horizontal and vertical travel use different easings, so the path is an arc rather than a straight line.
    const dx = to.left + to.width / 2 - rect.left - rect.width / 2, dy = to.top + to.height / 2 - rect.top - rect.height / 2;
    ghost.animate([{transform:'none'}, {transform:`translateX(${dx}px)`}], {duration:FLY, easing:'cubic-bezier(.3,.6,.4,1)', fill:'forwards'});
    card.animate([
      {transform:'none', opacity:1, easing:'cubic-bezier(.2,.7,.3,1)'},
      {transform:'translateY(-14px) scale(1.03)', opacity:1, offset:.24, easing:'cubic-bezier(.55,0,.85,.4)'},
      {transform:`translateY(${dy}px) scale(.14)`, opacity:0}
    ], {duration:FLY, fill:'forwards'}).finished.then(() => ghost.remove(), () => ghost.remove());
    if (hadCheckout) {
      checkout.animate([{transform:'scale(1)'}, {transform:'scale(.96)'}, {transform:'scale(1)'}], {duration:420, delay:LAND, easing:'ease-out'});
      return;
    }
    checkout.animate([{clipPath:'circle(0% at 50% 50%)'}, {clipPath:'circle(71% at 50% 50%)'}], {duration:620, delay:LAND, easing:'cubic-bezier(.22,1,.36,1)', fill:'backwards'});
    Array.from(checkout.children).forEach(el => el.animate([{opacity:0}, {opacity:1}], {duration:360, delay:LAND + 200, easing:'ease-out', fill:'backwards'}));
    drawer.querySelectorAll('.drawer-footer > :not(form):not(.cart-view-bag)').forEach((el, i) => el.animate([{opacity:0, transform:'translateY(12px)'}, {opacity:1, transform:'none'}], {duration:560, delay:LAND + 120 + i * 80, easing:'cubic-bezier(.22,1,.36,1)', fill:'backwards'}));
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('[data-product-form],[data-cart-change]')) return;
    event.preventDefault();
    if (cartBusy) return;
    cartBusy = true;
    const button = event.submitter, isAdd = form.matches('[data-product-form]'), error = form.querySelector('[data-form-error]');
    if (error) error.textContent = '';
    if (status) status.textContent = '';
    const tapped = isAdd && activePanel?.id === 'cart-drawer' && form.closest('.cart-rec');
    const flight = tapped && {rect:tapped.getBoundingClientRect(), card:copyCard(tapped), hadCheckout:!!document.querySelector('#cart-drawer .cart-checkout')};
    if (button) button.disabled = true;
    if (isAdd && !tapped) button?.classList.add('is-adding');
    form.setAttribute('aria-busy','true');
    try {
      const fields = new FormData(form);
      const body = isAdd ? {items:[{id:fields.get('id'),quantity:Math.max(1, Number(fields.get('quantity')) || 1)}]} : {id:fields.get('id'),quantity:button?.value === 'remove' ? 0 : Number(fields.get('quantity'))};
      await shopifyRequest(cartUrl + (isAdd ? '/add.js' : '/change.js'),body);
      await refreshCart();
      if (isAdd && !tapped) { button?.classList.remove('is-adding'); await flyToBag(form, button); }
      if (isAdd) openDrawer('cart-drawer',button);
      if (flight) flyToCheckout(flight);
      else {
        if (isAdd) revealBag();
        document.querySelector('#cart-drawer [data-drawer-close]')?.focus();
      }
      if (status) status.textContent = (document.documentElement.dataset.updated || 'Your bag has been updated.');
    } catch (failure) {
      if (error) error.textContent = failure.message;
      if (status) status.textContent = failure.message;
    } finally {
      cartBusy = false;
      if (button) { button.disabled = false; button.classList.remove('is-adding'); }
      form.removeAttribute('aria-busy');
    }
  });
  if (searchInput && searchResults) {
    let timer, controller;
    searchInput.addEventListener('input', () => {
      clearTimeout(timer);
      controller?.abort();
      searchResults.removeAttribute('aria-busy');
      const query = searchInput.value.trim();
      // Keep the previous suggestions until new ones arrive so the surface doesn't flicker on every keystroke.
      if (query.length < 2) {
        if (searchResults.childNodes.length) showResults(() => searchResults.replaceChildren());
        return;
      }
      timer = setTimeout(async () => {
        const request = new AbortController();
        controller = request;
        searchResults.setAttribute('aria-busy','true');
        try {
          const url = document.documentElement.dataset.predictiveUrl + '?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5';
          const response = await fetch(url,{signal:request.signal,credentials:'same-origin'});
          if (!response.ok) throw new Error('Search unavailable');
          const data = await response.json();
          if (request.signal.aborted) return;
          const list = document.createElement('ul');
          for (const product of data.resources.results.products) {
            const href = safeStoreUrl(product.url);
            if (!href) continue;
            const item = document.createElement('li'), link = document.createElement('a');
            link.href = href;
            link.textContent = product.title;
            item.append(link);
            list.append(item);
          }
          showResults(() => {
            searchResults.replaceChildren(list);
            if (!list.children.length) searchResults.textContent = (document.documentElement.dataset.noProducts || 'No matching products. Submit to view all search results.');
          });
        } catch (error) {
          if (error.name !== 'AbortError') showResults(() => { searchResults.textContent = (document.documentElement.dataset.unavailable || 'Suggestions unavailable. Submit your search to view results.'); });
        } finally { if (controller === request) searchResults.removeAttribute('aria-busy'); }
      },200);
    });
  }
  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const track = gallery.querySelector('[data-gallery-track]'), bar = gallery.querySelector('.pdp-progress span');
    const prev = gallery.querySelector('[data-gallery-step="-1"]'), next = gallery.querySelector('[data-gallery-step="1"]');
    const count = track.children.length, rtl = getComputedStyle(track).direction === 'rtl';
    const update = () => {
      const i = Math.round(Math.abs(track.scrollLeft) / Math.max(track.clientWidth, 1));
      bar?.style.setProperty('--index', i);
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= count - 1;
    };
    bar?.style.setProperty('--count', count);
    gallery.querySelectorAll('[data-gallery-step]').forEach(step => step.addEventListener('click', () => track.scrollBy({left:step.dataset.galleryStep * track.clientWidth * (rtl ? -1 : 1)})));
    track.addEventListener('scroll', update, {passive:true});
    update();
  });
  // The Story: its words light up in reading order as the paragraph scrolls through (one rAF-throttled pass).
  const reveals = [...document.querySelectorAll('[data-word-reveal]')].map(text => {
    const words = text.textContent.trim().split(/\s+/);
    text.textContent = '';
    words.forEach((word, i) => {
      const span = document.createElement('span');
      span.className = 'word';
      span.textContent = word;
      text.append(span, i < words.length - 1 ? ' ' : '');
    });
    return {text, words:[...text.querySelectorAll('.word')]};
  });
  if (reveals.length) {
    let queued = false;
    const light = () => {
      queued = false;
      for (const {text, words} of reveals) {
        const box = text.getBoundingClientRect();
        // Lit from when the paragraph's top reaches 85% of the viewport until its bottom passes 45%.
        const start = innerHeight * .85, end = innerHeight * .45;
        const progress = Math.min(1, Math.max(0, (start - box.top) / Math.max(start - end + box.height, 1)));
        const lit = Math.round(progress * words.length);
        words.forEach((word, i) => word.classList.toggle('is-lit', i < lit));
      }
    };
    addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(light); } }, {passive:true});
    addEventListener('resize', light);
    light();
  }
  // Notes on the bottle sketch: arrows run from each tier's label to its point on the drawing (fractions of the image
  // box), re-measured whenever the layout changes.
  document.querySelectorAll('[data-anatomy]').forEach(section => {
    const svg = section.querySelector('[data-anatomy-arrows]'), bottle = section.querySelector('[data-anatomy-bottle]');
    const groups = [...svg.querySelectorAll('g')], tiers = [...section.querySelectorAll('[data-anatomy-tier]')];
    const layout = () => {
      const box = svg.getBoundingClientRect(), art = bottle.getBoundingClientRect();
      if (!box.width || !art.width) return;
      svg.setAttribute('viewBox', `0 0 ${box.width} ${box.height}`);
      tiers.forEach((tier, i) => {
        const [line, tip, dot] = groups[i].children, label = tier.querySelector('[data-anatomy-anchor]').getBoundingClientRect();
        const right = label.left + label.width / 2 > art.left + art.width / 2, dir = right ? -1 : 1;
        const sx = (right ? label.left - 16 : label.right + 16) - box.left, sy = label.top + label.height / 2 - box.top;
        const ex = art.left + art.width * Number(tier.dataset[right ? 'txRight' : 'txLeft']) - box.left;
        const ey = art.top + art.height * Number(tier.dataset.ty) - box.top, mx = (sx + ex) / 2;
        line.setAttribute('d', `M${sx},${sy} C${mx},${sy} ${mx},${ey} ${ex - dir * 6},${ey}`);
        tip.setAttribute('d', `M${ex - dir * 16},${ey - 7} L${ex - dir * 6},${ey} L${ex - dir * 16},${ey + 7}`);
        dot.setAttribute('cx', ex); dot.setAttribute('cy', ey);
      });
    };
    new ResizeObserver(layout).observe(section.querySelector('.pdp-anatomy-stage'));
    bottle.addEventListener('load', layout);
    document.fonts?.ready.then(layout);
    layout();
  });
  // Quick navigation row: mark which physical edge still hides links (fade + chevron), step with the chevrons, and give
  // one gentle "there is more" glide per visit when it overflows. Any touch, wheel or focus stops the glide for good.
  const subnav = document.querySelector('[data-subnav]');
  const subnavList = subnav?.querySelector('.subnav-list');
  if (subnav && subnavList) {
    const markEdges = () => {
      const box = subnavList.getBoundingClientRect(), items = Array.from(subnavList.children, item => item.getBoundingClientRect());
      subnav.toggleAttribute('data-more-left', Math.min(...items.map(r => r.left)) < box.left - 1);
      subnav.toggleAttribute('data-more-right', Math.max(...items.map(r => r.right)) > box.right + 1);
    };
    subnavList.addEventListener('scroll', markEdges, {passive:true});
    new ResizeObserver(markEdges).observe(subnavList);
    subnav.querySelectorAll('[data-subnav-step]').forEach(button => button.addEventListener('click', () => {
      subnavList.scrollBy({left:button.dataset.subnavStep * subnavList.clientWidth * .6, behavior:'smooth'});
    }));
    let glide = null, stopped = false;
    const stopGlide = () => { stopped = true; if (glide) cancelAnimationFrame(glide); glide = null; };
    ['pointerdown', 'wheel', 'focusin', 'touchstart'].forEach(type => subnavList.addEventListener(type, stopGlide, {passive:true}));
    const range = subnavList.scrollWidth - subnavList.clientWidth;
    let seen = false;
    try { seen = sessionStorage.getItem('zamara-subnav-glide') === '1'; sessionStorage.setItem('zamara-subnav-glide', '1'); } catch { seen = true; }
    if (range > 8 && !seen) {
      // Out to the far end and back at reading pace (native scroll position, eased), then the strip is left alone.
      const sign = getComputedStyle(subnavList).direction === 'rtl' ? -1 : 1, leg = Math.max(1600, range * 18);
      const ease = t => t < .5 ? 2 * t * t : 1 - (-2 * t + 2) ** 2 / 2;
      let start = 0;
      const step = now => {
        if (stopped) return;
        if (!start) start = now;
        const t = (now - start) / leg;
        if (t >= 2.4) { subnavList.scrollLeft = 0; glide = null; return; }
        const out = t < 1 ? ease(t) : t < 1.4 ? 1 : 1 - ease(Math.min(1, t - 1.4));
        subnavList.scrollLeft = sign * range * out;
        glide = requestAnimationFrame(step);
      };
      setTimeout(() => { if (!stopped && !document.hidden) glide = requestAnimationFrame(step); }, 1400);
    }
    markEdges();
  }
  // Cookie consent is stored only by Shopify's Customer Privacy API (snippets/cookie-consent.liquid). Until the
  // visitor answers, optional processing is off; the unanswered "preferences" value is what keeps the banner up.
  // Shopify's own cookie banner (Settings > Customer privacy) is hidden in luxury-theme.css: this one asks instead.
  const consent = document.getElementById('CookieConsent');
  if (consent && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], error => {
      const privacy = window.Shopify.customerPrivacy;
      if (error || !privacy) return;
      let opener = null;
      const measure = () => { if (!consent.hidden) document.documentElement.style.setProperty('--consent-height', consent.offsetHeight + 'px'); };
      const show = () => { consent.hidden = false; measure(); };
      // Leaving reverses the entrance: rise + fade back out.
      const hide = async () => {
        const frames = [{opacity:1, transform:'none'},{opacity:0, transform:'translateY(24px)'}];
        try { await consent.animate(frames, {duration:450, easing:'cubic-bezier(.22,1,.36,1)', fill:'forwards'}).finished; } catch { /* Interrupted: hide anyway. */ }
        consent.hidden = true;
        consent.getAnimations().forEach(animation => animation.cancel());
      };
      window.addEventListener('resize', measure, {passive:true});
      document.querySelectorAll('[data-consent-open]').forEach(button => {
        button.closest('li').hidden = false;
        button.addEventListener('click', () => { opener = button; show(); consent.querySelector('[data-consent]').focus(); });
      });
      consent.addEventListener('click', event => {
        const choice = event.target.closest('[data-consent]');
        if (!choice) return;
        const value = choice.dataset.consent === 'all';
        privacy.setTrackingConsent({analytics:value, marketing:value, preferences:value, sale_of_data:value}, result => {
          if (result?.error) return;
          hide().then(() => opener?.focus());
        });
      });
      const step = consentStep(privacy.currentVisitorConsent());
      if (step.restrict) privacy.setTrackingConsent({analytics:false, marketing:false, sale_of_data:false}, () => {});
      if (step.show) show();
    });
  }
});
